import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdvisorClientsPage = lazy(() => import("@/features/dashboard/pages/advisor-clients"));

export const Route = createFileRoute("/(app)/dashboard/advisor/clients")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground p-6 text-sm">Loading client registry...</div>}>
      <AdvisorClientsPage />
    </Suspense>
  ),
});
